module.exports = __webpack_public_path__ + "static/img/321.1c5c01b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/rjzz/321.jpg
// module id = NInv
// module chunks = 0